var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{class:`fa-solid fa-${_vm.style.ico} fa-2x ${_vm.style.color}`})
}
var staticRenderFns = []

export { render, staticRenderFns }